// ─── SCROLL HEADER ───
const navEl = document.querySelector('.nav');
if (navEl) {
  let ticking = false;
  function updateNav() {
    navEl.classList.toggle('nav--scrolled', window.scrollY > 60);
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(updateNav); ticking = true; }
  }, { passive: true });
  updateNav(); // set correct state on load (e.g. if user refreshes mid-page)
}

// ─── MOBILE NAV ───
const burger = document.querySelector('.nav-burger');
const mobileNav = document.getElementById('mobile-nav');
const mobileOverlay = document.querySelector('.mobile-nav-overlay');
const mobileClose = document.querySelector('.mobile-nav-close');

function openNav() {
  mobileNav.classList.add('open');
  mobileOverlay.classList.add('open');
  burger && burger.classList.add('open');
  burger && burger.setAttribute('aria-expanded', 'true');
  mobileNav.setAttribute('aria-hidden', 'false');
}
function closeNav() {
  mobileNav.classList.remove('open');
  mobileOverlay.classList.remove('open');
  burger && burger.classList.remove('open');
  burger && burger.setAttribute('aria-expanded', 'false');
  mobileNav.setAttribute('aria-hidden', 'true');
}
if (burger) burger.addEventListener('click', openNav);
if (mobileClose) mobileClose.addEventListener('click', closeNav);
if (mobileOverlay) mobileOverlay.addEventListener('click', closeNav);

// ─── CURSOR ───
const cur = document.getElementById('cur');
if (cur && window.matchMedia('(pointer: fine)').matches) {
  // rAF throttle — only one transform update per frame (GPU composited)
  let curRaf = null;
  document.addEventListener('mousemove', e => {
    if (curRaf) return;
    curRaf = requestAnimationFrame(() => {
      cur.style.transform = 'translate(' + (e.clientX - 18) + 'px,' + (e.clientY - 18) + 'px)';
      curRaf = null;
    });
  }, { passive: true });

  // Event delegation — one listener instead of one per element
  const growSel  = 'a, button, select, .cg-item, .fs-item, .clist-item, .dg-item, .product-card, .float-cta, .pdc-size-btn, [data-cursor-grow]';
  // Only hide the cursor over text-entry fields, where the native caret is
  // what you actually need. A <select> is a click target, not a text field —
  // hiding there left no cursor at all, since CSS also sets cursor:none.
  const hideSel  = 'input:not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button]), textarea';
  document.addEventListener('mouseover', e => {
    if (e.target.closest(hideSel))  { cur.classList.add('hidden'); cur.classList.remove('grow'); return; }
    if (e.target.closest(growSel))  { cur.classList.add('grow'); }
  });
  document.addEventListener('mouseout', e => {
    if (e.target.closest(hideSel))  cur.classList.remove('hidden');
    if (e.target.closest(growSel))  cur.classList.remove('grow');
  });
}

// ─── LIVE CLOCK (PHX local time) ───
const clockEl = document.getElementById('clock');
if (clockEl) {
  const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  function tick() {
    const n = new Date();
    const phx = new Date(n.toLocaleString('en-US', { timeZone: 'America/Phoenix' }));
    const h = String(phx.getHours()).padStart(2,'0');
    const m = String(phx.getMinutes()).padStart(2,'0');
    const s = String(phx.getSeconds()).padStart(2,'0');
    clockEl.textContent = `PHX, AZ — ${months[phx.getMonth()]} ${phx.getDate()} — ${h}:${m}:${s}`;
  }
  tick();
  setInterval(tick, 1000);
}

// ─── HERO SLIDESHOW ───
(function() {
  const hero = document.querySelector('[data-slideshow]');
  if (!hero) return;

  const slides    = Array.from(hero.querySelectorAll('.hero-slide'));
  const dots      = Array.from(hero.querySelectorAll('.hero-dot'));
  const prevBtn   = hero.querySelector('.hero-arrow--prev');
  const nextBtn   = hero.querySelector('.hero-arrow--next');
  const progBar   = hero.querySelector('.hero-progress-bar');
  const duration  = (parseInt(hero.dataset.duration) || 5) * 1000;

  if (slides.length < 2) return;

  let current  = 0;
  let timer    = null;
  let paused   = false;

  function goTo(index) {
    slides[current].classList.remove('active');
    dots[current] && dots[current].classList.remove('active');
    dots[current] && dots[current].setAttribute('aria-selected', 'false');

    current = (index + slides.length) % slides.length;

    slides[current].classList.add('active');
    dots[current] && dots[current].classList.add('active');
    dots[current] && dots[current].setAttribute('aria-selected', 'true');

    // Restart progress bar
    if (progBar) {
      progBar.classList.remove('running');
      void progBar.offsetWidth; // force reflow
      progBar.classList.add('running');
    }
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(() => {
      if (!paused) goTo(current + 1);
    }, duration);
  }

  // Arrow buttons
  prevBtn && prevBtn.addEventListener('click', () => { goTo(current - 1); startTimer(); });
  nextBtn && nextBtn.addEventListener('click', () => { goTo(current + 1); startTimer(); });

  // Dot buttons
  dots.forEach(dot => {
    dot.addEventListener('click', () => { goTo(parseInt(dot.dataset.index)); startTimer(); });
  });

  // Pause on hover
  hero.addEventListener('mouseenter', () => { paused = true; });
  hero.addEventListener('mouseleave', () => { paused = false; });

  // Kick it off
  goTo(0);
  startTimer();
})();

// ─── SCROLL REVEALS ───
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('on'); });
}, { threshold: 0.07 });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

// ─── FILMSTRIP DRAG ───
const fsTrack = document.getElementById('fsTrack');
if (fsTrack) {
  let dn = false, sx, sl;
  fsTrack.addEventListener('mousedown', e => { dn = true; sx = e.pageX - fsTrack.offsetLeft; sl = fsTrack.scrollLeft; });
  fsTrack.addEventListener('mouseleave', () => dn = false);
  fsTrack.addEventListener('mouseup', () => dn = false);
  fsTrack.addEventListener('mousemove', e => {
    if (!dn) return;
    e.preventDefault();
    fsTrack.scrollLeft = sl - (e.pageX - fsTrack.offsetLeft - sx) * 1.5;
  });
}

// ─── VARIANT SELECTOR ───
const variantSelect = document.querySelector('[data-variant-select]');
if (variantSelect) {
  variantSelect.addEventListener('change', e => {
    const addBtn = document.querySelector('[data-add-to-cart]');
    const priceEl = document.querySelector('[data-product-price]');
    const selected = e.target.options[e.target.selectedIndex];
    if (addBtn) {
      addBtn.disabled = selected.dataset.available === 'false';
      addBtn.textContent = selected.dataset.available === 'false' ? '[Sold Out]' : '[Add to Bag]';
    }
    if (priceEl && selected.dataset.price) {
      priceEl.textContent = selected.dataset.price;
    }
  });
}

// ─── PRODUCT CACHE ───
const productCache = new Map();
async function fetchProduct(handle) {
  if (productCache.has(handle)) return productCache.get(handle);
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    const product = await res.json();
    productCache.set(handle, product);
    return product;
  } catch { return null; }
}

// ─── CART DRAWER ───
const cartDrawer    = document.getElementById('cartDrawer');
const cartOverlay   = document.getElementById('cartDrawerOverlay');
const cartClose     = document.getElementById('cartDrawerClose');
const cartBody      = document.getElementById('cartDrawerBody');
const cartTotal     = document.getElementById('cartDrawerTotal');
const cartDrawerCount = document.getElementById('cartDrawerCount');

function openCartDrawer() {
  cartDrawer.classList.add('open');
  cartOverlay.classList.add('open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeCartDrawer() {
  cartDrawer.classList.remove('open');
  cartOverlay.classList.remove('open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

if (cartClose)   cartClose.addEventListener('click', closeCartDrawer);
if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCartDrawer(); });

// Open drawer when clicking cart link (instead of navigating)
document.querySelectorAll('.nav-cart').forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    refreshCartDrawer().then(openCartDrawer);
  });
});

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function renderCartDrawer(cart) {
  // Nav counts + shine class
  document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  document.querySelectorAll('.nav-cart').forEach(el => {
    el.classList.toggle('nav-cart--active', cart.item_count > 0);
  });

  // Drawer header
  if (cartDrawerCount) {
    cartDrawerCount.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
  }
  if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);

  // Items
  if (!cartBody) return;
  if (cart.item_count === 0) {
    cartBody.innerHTML = `
      <div class="cart-drawer-empty">
        <p>Your cart is empty.</p>
        <a href="/collections/all">Continue Shopping</a>
      </div>`;
  } else {
    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-drawer-item" data-key="${item.key}">
        <div class="cdi-img">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
        </div>
        <div class="cdi-details">
          <p class="cdi-title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cdi-variant">${item.variant_title}</p>` : ''}
          <p class="cdi-price">${formatMoney(item.original_price)}</p>
          <div class="cdi-qty-row">
            <button class="cdi-qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}">−</button>
            <span class="cdi-qty">${item.quantity}</span>
            <button class="cdi-qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
            <button class="cdi-remove" data-key="${item.key}">Remove</button>
          </div>
        </div>
      </div>`).join('');
    bindCartDrawerEvents();
  }

  // Free shipping progress
  renderShipNudge(cart);

  // Upsells
  renderPinUpsell(cart);
  updateSprayToggle(cart);
}

// ─── FREE SHIPPING NUDGE ───
function renderShipNudge(cart) {
  const el = document.getElementById('cartShipNudge');
  if (!el) return;

  const threshold = parseInt(el.dataset.threshold, 10);
  if (!threshold || cart.item_count === 0) {
    el.hidden = true;
    return;
  }
  el.hidden = false;

  const msg  = document.getElementById('cartShipNudgeMsg');
  const fill = document.getElementById('cartShipNudgeFill');
  const remaining = threshold - cart.total_price;

  if (remaining > 0) {
    el.classList.remove('is-unlocked');
    if (msg) msg.innerHTML = '<strong>' + formatMoney(remaining) + '</strong> away from free US shipping';
    if (fill) fill.style.width = ((cart.total_price / threshold) * 100).toFixed(1) + '%';
  } else {
    el.classList.add('is-unlocked');
    if (msg) msg.textContent = 'Free US shipping unlocked';
    if (fill) fill.style.width = '100%';
  }
}

// ─── PIN UPSELL ───
async function renderPinUpsell(cart) {
  const container = document.getElementById('cartUpsellPin');
  if (!container) return;

  // Fetch all cart item products in parallel (cached)
  const cartHandles = [...new Set(cart.items.map(i => i.handle))];
  const products = await Promise.all(cartHandles.map(h => fetchProduct(h)));

  // Build lookup: handle → product
  const productMap = new Map();
  cartHandles.forEach((h, i) => { if (products[i]) productMap.set(h, products[i]); });

  // Collect unique pair handles from every upsell-pin tagged item in cart
  // A set prevents duplicates when multiple hats share the same pairs-with tag
  const cartHandleSet = new Set(cartHandles);
  const pairHandleSet = new Set();

  for (const item of cart.items) {
    const product = productMap.get(item.handle);
    if (!product || !Array.isArray(product.tags)) continue;
    if (!product.tags.includes('upsell-pin')) continue;
    const pairsTag = product.tags.find(t => t.startsWith('pairs-with:'));
    if (!pairsTag) continue;
    const pairHandle = pairsTag.split(':')[1].trim();
    // Skip if that pin is already a line item in the cart
    if (!cartHandleSet.has(pairHandle)) pairHandleSet.add(pairHandle);
  }

  if (pairHandleSet.size === 0) { container.innerHTML = ''; return; }

  // Fetch each unique pin product (cached)
  const pinProducts = await Promise.all([...pairHandleSet].map(h => fetchProduct(h)));
  const validPins = pinProducts.filter(p => {
    if (!p || !p.available) return false;
    const v = p.variants && p.variants[0];
    return v && v.available;
  });

  if (validPins.length === 0) { container.innerHTML = ''; return; }

  // Render header once + one card per unique pin
  let html = `<p class="cup-header">Pairs with this drop</p>`;

  for (const pin of validPins) {
    const variant = pin.variants[0];
    const imgSrc = pin.featured_image
      ? pin.featured_image.replace(/(\.[a-z]+)$/, '_120x$1')
      : '';
    html += `
      <div class="cart-upsell-pin-card">
        <div class="cup-img">${imgSrc ? `<img src="${imgSrc}" alt="${pin.title}" loading="lazy">` : ''}</div>
        <div class="cup-info">
          <p class="cup-label">Add on</p>
          <p class="cup-name">${pin.title}</p>
          <p class="cup-price">${formatMoney(variant.price)}</p>
        </div>
        <button class="cup-add-btn" data-variant="${variant.id}">[+Add]</button>
      </div>`;
  }

  container.innerHTML = html;

  container.querySelectorAll('.cup-add-btn').forEach(btn => {
    btn.addEventListener('click', async e => {
      const b = e.currentTarget;
      b.textContent = '...';
      b.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(b.dataset.variant), quantity: 1 })
        });
        if (res.ok) await refreshCartDrawer();
        else { b.textContent = '[+Add]'; b.disabled = false; }
      } catch { b.textContent = '[+Add]'; b.disabled = false; }
    });
  });
}

// ─── SPRAY UPSELL ───
let sprayVariantId = null;

async function initSprayUpsell() {
  const sprayEl = document.getElementById('cartUpsellSpray');
  if (!sprayEl) return;
  const product = await fetchProduct(sprayEl.dataset.handle);
  if (!product) return;
  sprayVariantId = product.variants[0].id;
}

function updateSprayToggle(cart) {
  const toggle = document.getElementById('sprayToggle');
  if (!toggle || !sprayVariantId) return;
  toggle.checked = cart.items.some(i => i.variant_id === sprayVariantId);
}

document.addEventListener('change', async e => {
  if (e.target.id !== 'sprayToggle' || !sprayVariantId) return;
  if (e.target.checked) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: sprayVariantId, quantity: 1 })
    });
  } else {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const item = cart.items.find(i => i.variant_id === sprayVariantId);
    if (item) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }
  }
  await refreshCartDrawer();
});

initSprayUpsell();

function bindCartDrawerEvents() {
  cartBody.querySelectorAll('.cdi-qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const qty = parseInt(btn.dataset.qty);
      const newQty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      await updateCartItem(key, newQty);
    });
  });

  cartBody.querySelectorAll('.cdi-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      await updateCartItem(btn.dataset.key, 0);
    });
  });
}

async function updateCartItem(key, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const cart = await res.json();
    renderCartDrawer(cart);
  } catch(err) { console.error(err); }
}

async function refreshCartDrawer() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCartDrawer(cart);
    return cart;
  } catch(err) { console.error(err); }
}

// ─── CART PAGE ───
const cpPage = document.querySelector('[data-cp-page]');
if (cpPage) {
  async function cpChange(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      window.location.reload();
    } catch(err) { console.error(err); }
  }

  cpPage.querySelectorAll('.cp-qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const qty = parseInt(btn.dataset.qty);
      const newQty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      // Optimistic UI update
      const row = btn.closest('.cp-item');
      if (row) {
        const valEl = row.querySelector('.cp-qty-val');
        if (valEl) valEl.textContent = newQty;
        row.querySelectorAll('.cp-qty-btn').forEach(b => b.dataset.qty = newQty);
      }
      cpChange(btn.dataset.key, newQty);
    });
  });

  cpPage.querySelectorAll('.cp-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const row = btn.closest('.cp-item');
      if (row) row.style.opacity = '0.3';
      cpChange(btn.dataset.key, 0);
    });
  });
}

// ─── PREDICTIVE SEARCH ───
(function() {
  const overlay   = document.getElementById('searchOverlay');
  const card      = overlay && overlay.querySelector('.search-card');
  const input     = document.getElementById('searchInput');
  const results   = document.getElementById('searchResults');
  const openBtn   = document.getElementById('searchOpen');
  const closeBtn  = document.getElementById('searchClose');
  const mobOpen   = document.getElementById('mobileSearchOpen');

  if (!overlay || !input || !results) return;

  let debounceTimer = null;
  let activeQuery   = '';

  function openSearch() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    openBtn && openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 80);
    if (results.innerHTML === '') showPrompt();
  }

  function closeSearch() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    openBtn && openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    input.value = '';
    results.innerHTML = '';
    activeQuery = '';
  }

  if (openBtn)  openBtn.addEventListener('click', openSearch);
  if (mobOpen)  mobOpen.addEventListener('click', () => { closeNav && closeNav(); openSearch(); });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  // Close on backdrop click (outside card)
  overlay.addEventListener('click', e => {
    if (!card.contains(e.target)) closeSearch();
  });

  // Close on Escape (extend existing keydown listener)
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('open')) closeSearch();
  });

  // Hide/show custom cursor over search input
  if (cur) {
    input.addEventListener('mouseenter', () => cur.classList.add('hidden'));
    input.addEventListener('mouseleave', () => cur.classList.remove('hidden'));
  }

  function showPrompt() {
    results.innerHTML = '<div class="search-prompt">Start typing to search products...</div>';
  }

  function formatSearchPrice(price) {
    // Predictive Search API returns price as a decimal (e.g. 45.00), not cents
    if (price === null || price === undefined) return '';
    const num = parseFloat(price);
    if (isNaN(num)) return '';
    return '$' + num.toFixed(2);
  }

  async function runSearch(q) {
    if (q.length < 2) { showPrompt(); return; }
    activeQuery = q;
    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][fields]=title,tag,variants.title`
      );
      if (!res.ok) return;
      const data = await res.json();
      if (activeQuery !== q) return; // stale response — ignore

      const products = data.resources && data.resources.results && data.resources.results.products;
      if (!products || products.length === 0) {
        results.innerHTML = `<div class="search-empty">No results for &ldquo;${q}&rdquo;</div>`;
        return;
      }

      results.innerHTML = products.map(p => {
        const imgUrl = p.featured_image && p.featured_image.url
          ? p.featured_image.url + (p.featured_image.url.includes('?') ? '&' : '?') + 'width=120'
          : '';
        const imgTag = imgUrl ? `<img src="${imgUrl}" alt="${p.title}" loading="lazy">` : '';
        const price = formatSearchPrice(p.price_min !== undefined ? p.price_min : p.price);
        return `
          <a class="search-result-item" href="${p.url}">
            <div class="sri-img">${imgTag}</div>
            <div class="sri-info">
              <span class="sri-title">${p.title}</span>
              ${price ? `<span class="sri-price">${price}</span>` : ''}
            </div>
            <span class="sri-arrow">→</span>
          </a>`;
      }).join('');

      // Bind cursor grow on new result links
      if (cur) {
        results.querySelectorAll('.search-result-item').forEach(el => {
          el.addEventListener('mouseenter', () => cur.classList.add('grow'));
          el.addEventListener('mouseleave', () => cur.classList.remove('grow'));
        });
      }
    } catch(err) { console.error('Search error:', err); }
  }

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const q = input.value.trim();
    if (q.length === 0) { showPrompt(); return; }
    debounceTimer = setTimeout(() => runSearch(q), 220);
  });
})();

// ─── EDITORIAL SIZE SELECTOR ───
document.querySelectorAll('[data-ed-sizes]').forEach(function(sizeWrap) {
  const card        = sizeWrap.closest('.product-data-card');
  const variantInput = card && card.querySelector('[data-ed-variant-input]');
  const priceEl     = card && card.querySelector('[data-ed-price]');
  const addBtn      = card && card.querySelector('[data-add-to-cart]');

  sizeWrap.querySelectorAll('.pdc-size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Active state
      sizeWrap.querySelectorAll('.pdc-size-btn').forEach(b => b.classList.remove('pdc-size-active'));
      btn.classList.add('pdc-size-active');

      // Update hidden input
      if (variantInput) variantInput.value = btn.dataset.variantId;

      // Update price
      if (priceEl) priceEl.textContent = btn.dataset.price;

      // Update button state
      if (addBtn) {
        const available = btn.dataset.available === 'true';
        addBtn.disabled = !available;
        if (!available) addBtn.textContent = '[Sold Out]';
        else addBtn.textContent = addBtn.dataset.origText || addBtn.textContent;
      }

      // Cursor grow bind for new buttons isn't needed — already bound globally
    });
  });

  // Store original button text for restoration
  if (addBtn) addBtn.dataset.origText = addBtn.textContent.trim();
});

// ─── AJAX ADD TO CART ───
document.querySelectorAll('[data-add-to-cart-form]').forEach(form => {
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart]');
    const orig = btn.textContent;
    btn.textContent = '[Adding...]';
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt(form.querySelector('[name="quantity"]')?.value || 1)
        })
      });
      if (res.ok) {
        btn.textContent = '[Added]';
        await refreshCartDrawer();
        openCartDrawer();
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1800);
      } else {
        btn.textContent = '[Error]';
        btn.disabled = false;
      }
    } catch {
      btn.textContent = orig;
      btn.disabled = false;
    }
  });
});

// ─── MEGA MENU ───
// Hover to open on fine pointers; focus/Escape keep it keyboard-usable.
(function () {
  const items = document.querySelectorAll('[data-megamenu]');
  if (!items.length) return;

  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  let closeTimer = null;

  function open(item) {
    clearTimeout(closeTimer);
    items.forEach(i => { if (i !== item) setState(i, false); });
    setState(item, true);
  }
  function close(item, delay) {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => setState(item, false), delay || 0);
  }
  function setState(item, isOpen) {
    item.classList.toggle('is-open', isOpen);
    const trigger = item.querySelector('.nav-link');
    const panel = item.querySelector('[data-megamenu-panel]');
    if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (panel) panel.hidden = !isOpen;
  }

  items.forEach(item => {
    const panel = item.querySelector('[data-megamenu-panel]');
    if (panel) panel.hidden = true;

    if (fine) {
      item.addEventListener('mouseenter', () => open(item));
      item.addEventListener('mouseleave', () => close(item, 120));
      if (panel) {
        panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
        panel.addEventListener('mouseleave', () => close(item, 120));
      }
    }

    // Keyboard: opening on focus lets tab order walk into the panel
    item.addEventListener('focusin', () => open(item));
    item.addEventListener('focusout', () => {
      if (!item.contains(document.activeElement)) close(item, 80);
    });
  });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    items.forEach(i => {
      if (!i.classList.contains('is-open')) return;
      setState(i, false);
      const t = i.querySelector('.nav-link');
      if (t) t.focus();
    });
  });
})();

// ─── QUICK ADD (product cards) ───
// Delegated so it covers cards rendered by any section. Reuses the existing
// cart drawer helpers rather than duplicating cart logic.
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn || btn.disabled) return;

  // The button sits outside the card link, but stop propagation anyway so a
  // future markup change can't turn an add into a navigation.
  e.preventDefault();
  e.stopPropagation();

  const wrap = btn.closest('[data-quick]');
  const select = wrap ? wrap.querySelector('[data-quick-select]') : null;
  const variantId = select ? select.value : btn.dataset.variantId;
  if (!variantId) return;

  const orig = btn.textContent;
  btn.textContent = '[Adding...]';
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (res.ok) {
      btn.textContent = '[Added]';
      if (typeof refreshCartDrawer === 'function') await refreshCartDrawer();
      if (typeof openCartDrawer === 'function') openCartDrawer();
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1400);
    } else {
      // Most common cause: the variant sold out between page load and click
      const body = await res.json().catch(() => ({}));
      btn.textContent = body.description ? '[Unavailable]' : '[Error]';
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1800);
    }
  } catch {
    btn.textContent = '[Error]';
    setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1800);
  }
});

// Changing the variant inside a card must not follow the card link
document.addEventListener('click', e => {
  if (e.target.closest('[data-quick-select]')) e.stopPropagation();
});
